import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface NewButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

/**
 * Reusable New Chat button component
 * Provides consistent styling and behavior for creating new conversations
 */
const NewButton: React.FC<NewButtonProps> = ({ onClick, disabled = false, label = 'New Chat' }) => {
  return (
    <Button 
      icon={<PlusOutlined />} 
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default NewButton;